import * as React from 'react';
import { IAppPropsWithRoute } from '../../common/types';
import { withRouter } from 'react-router-dom';
import { useState } from 'react';
import AddEditUser from './AddEditUserWidget';
import { useDispatch, useSelector } from 'react-redux';
import { showNavbar } from '../../store/modules/appStateSlice';

interface AddEditUserPageProps extends IAppPropsWithRoute {

};

function AddEditUserPage(props: AddEditUserPageProps): JSX.Element {
    const dispatch = useDispatch();
    //const { authStore } = useSelector((state: RootState) => state);
    React.useEffect(() => {
        dispatch(showNavbar(true));
    }, [])
    const userId = props.match.params.userId;

    const renderChild = () => {
        return <AddEditUser userId={userId} />;
    }

    return (
        <React.Fragment>
            {renderChild()}
        </React.Fragment>
    );
}

export default React.memo(withRouter(AddEditUserPage));